var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "40px",
    viewBox: "0 0 28 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Tag_1815253") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Courses/Games",
    transform: "translate(-606.000000, -324.000000)",
    fill: "#93D578",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(50.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Tag_1815253",
    transform: "translate(215.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8052209,0 L1.19477912,0 C0.534136546,0 0,0.523415978 0,1.1707989 L0,38.815427 C0,39.2699725 0.267068273,39.6694215 0.674698795,39.8760331 C1.08232932,40.0688705 1.57429719,40.0137741 1.93975904,39.738292 L14,30.2892562 L26.060241,39.738292 C26.2710843,39.9035813 26.5381526,40 26.8052209,40 C26.9879518,40 27.1566265,39.9586777 27.3253012,39.8898072 C27.7329317,39.6969697 28,39.2837466 28,38.8292011 L28,1.1707989 C28,0.523415978 27.4658635,0 26.8052209,0 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkGreen);
export default __webpack_public_path__ + "static/media/bookmark-green.5256c6f333f6fec0a091d4b9f52d5338.svg";
export { ForwardRef as ReactComponent };